import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter as Router } from "react-router-dom";
import "./assets/css/Style.css";
import ToastComponent from "components/snackbar";
import { baseDarkTheme } from "./utils/theme/DefaultColors";
import { AuthProvider } from "./provider/authProvider";
import AppRoutes from "routes/routes";

const queryClient = new QueryClient();

const App = () => {
  console.log("SubAdmin Working ");
  return (
    <React.StrictMode>
      <ToastComponent />
      <ThemeProvider theme={baseDarkTheme}>
        <QueryClientProvider client={queryClient}>
          <Router>
            <AuthProvider>
              <AppRoutes />
            </AuthProvider>
          </Router>
        </QueryClientProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
